import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["emails"]
  static values = { id: Number }

  initialize() {
    this.userEmails(this.idValue, this.emailsTarget)
  }

  userEmails(user_id, target) {
    $.getJSON(`/admin/users/${user_id}/emails_received`, function (data) {
      $(target).html("")

      if (data.TotalCount === 0) {
        $(target).append("No emails sent recently.")
        return
      }

      return data.Messages.forEach((message) => {
        let status = "<span class='badge badge-success'>Sent</span>"
        if (message.Status !== "Sent") {
          status = `<span class='badge badge-danger'>${message.Status}</span>`
        }

        // To prevent XSS
        const p = $("<p />")
        p.text(`Received at ${message.ReceivedAt}. Subject: ${message.Subject}`)

        let permalink = `https://account.postmarkapp.com/servers/1894135/streams/outbound/messages/${message.MessageID}`

        return $(target).append(`<p><a href="${permalink}" target="_blank">${status}</a> ${p.html()}</p>`)
      })
    })
  }
}
